import type { FaireProductEntity } from "../../entity_types/product";

export const p_yyhju65key: FaireProductEntity = {
  token: "p_yyhju65key",
  type: "product",
  name: "Complete Thyroid Cookbook",
  brandToken: "b_14eeavl3ro",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/93f25448a3c16c1e5477408a1b01d96979e01e07ac20b3db60fbbfa4cf3191a6.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.85,
  description: "Manage thyroid health through nutrition with this all-in-one resource \rIt’s easier than you think to eat hearty and delicious meals that help relieve the symptoms of thyroid disease. This thyroid cookbook breaks down the connection between thyroid health and food in simple terms. Then, it explains how to put the information to good use with guided meal plans and flavorful recipes that help you feel better naturally.  Evidence-based diet advice—This thyroid cookbook explains three different thyroid-friendly diets: Paleo, Autoimmune Protocol, and Elimination Provocation.\r Prepare to eat well—Find 85 affordable recipes for everything from dinner to sweets and snacks, with detailed meal plans for each diet.\r No experience required—Even casual cooks will find everything they need for success with this thyroid cookbook full of clear instructions, shopping lists, and recipes that are quick to put together.\r  \rEat what you love and manage thyroid symptoms with The Complete Thyroid Cookbook.",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:48.812Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
